import { Image } from '@/shared/ui/image';
import { useWishlist } from '../model/hooks';
import { Box } from '@/shared/ui/box';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { Condition } from '@/shared/ui/condition';
import { useToast } from '@/shared/providers/toast-provider/ToastProvider';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { WishlistButtonMobile } from './styles';
import { BodyTextRegularSecondary } from '@/shared/ui/typography';
import { useScopedI18n } from '@locales/client';

const WishlistToggle = ({ gameId, title, mobileLandscape }) => {
  const { trigger } = useWishlist();
  const { user, mutateWishlist } = useUser();
  const { showToast } = useToast();
  const loc = useScopedI18n('common.game.dockbar');
  const isInWishlist = user.isAuth && user.wishlist.includes(gameId);

  const handleToggle = async (e) => {
    e.stopPropagation();
    try {
      await trigger({
        gameId,
        val: !isInWishlist,
      });
      mutateWishlist();
      // showToast({
      //   type: 'success',
      //   message: !isInWishlist
      //     ? `${title} added to favorites`
      //     : `${title} removed from favorites`,
      // });
    } catch (error) {}
  };

  if (mobileLandscape) {
    return (
      <Condition match={user.isAuth}>
        <Box
          $display={'flex'}
          $justifyContent={'flex-end'}
          $alignItems="center"
          $gap={12}
        >
          <Condition match={!isInWishlist}>
            <BodyTextRegularSecondary color={'#AFAFAF'}>
              {loc('favorite')}
            </BodyTextRegularSecondary>
          </Condition>
          <Condition match={isInWishlist}>
            <BodyTextRegularSecondary color={'#AFAFAF'}>
              {loc('unfavorite')}
            </BodyTextRegularSecondary>
          </Condition>
          <Box>
            <WishlistButtonMobile
              $isSelected={isInWishlist}
              variant="gray"
              style={{
                padding: '0',
                borderRadius: '100px',
                height: '40px',
                width: '40px',
              }}
              icon={
                <Image
                  width={20}
                  height={20}
                  src={
                    isInWishlist
                      ? '/images/icons/heart-filled.svg'
                      : '/images/icons/heart-unfilled.svg'
                  }
                />
              }
              onClick={handleToggle}
            ></WishlistButtonMobile>
          </Box>
        </Box>
      </Condition>
    );
  }

  return (
    <Condition match={user.isAuth}>
      <Box onClick={handleToggle}>
        <Image
          width={20}
          height={20}
          src={
            isInWishlist
              ? '/images/icons/heart-filled.svg'
              : '/images/icons/heart-unfilled.svg'
          }
        />
      </Box>
    </Condition>
  );
};

const WishlistToggleWithBreakpointsSlice = withBreakpointsSlice(
  WishlistToggle,
  ({ mobileLandscape }) => ({
    mobileLandscape,
  })
);

export { WishlistToggleWithBreakpointsSlice as WishlistToggle };
